// export { default as vuex } from './vuex'
export { default as routes } from './routes'
export { default as vuex } from './vuex'